// services/childcare/registration.js
import { api, uploadApi, formatPhoneNumber } from "./utils";

// Check if email exists
export const checkEmailExists = async (email) => {
  try {
    const response = await api.get(
      `/childcare/check-email/${encodeURIComponent(email)}`,
    );
    return response.data;
  } catch (error) {
    console.error("Check email error:", error);
    throw error;
  }
};

// Check if phone exists
export const checkPhoneExists = async (phone) => {
  try {
    const formattedPhone = formatPhoneNumber(phone);
    const response = await api.get(
      `/childcare/check-phone/${encodeURIComponent(formattedPhone)}`,
    );
    return response.data;
  } catch (error) {
    console.error("Check phone error:", error);
    throw error;
  }
};

// Send Email OTP
export const sendEmailOtp = async (email) => {
  try {
    const response = await api.post("/childcare/send-email-otp", { email });
    return response;
  } catch (error) {
    console.error("Send email OTP error:", error);
    throw error;
  }
};

// Verify Email OTP
export const verifyEmailOtp = async (email, otp) => {
  try {
    const response = await api.post("/childcare/verify-email-otp", {
      email,
      otp,
    });
    return response;
  } catch (error) {
    console.error("Verify email OTP error:", error);
    throw error;
  }
};

// Send Phone OTP
export const sendPhoneOtp = async (phone, email = null) => {
  try {
    const formattedPhone = formatPhoneNumber(phone);
    const response = await api.post("/childcare/send-phone-otp", {
      phone: formattedPhone,
      email,
    });
    return response;
  } catch (error) {
    console.error("Send phone OTP error:", error);
    throw error;
  }
};

// Verify Phone OTP
export const verifyPhoneOtp = async (phone, otp) => {
  try {
    const formattedPhone = formatPhoneNumber(phone);
    const response = await api.post("/childcare/verify-phone-otp", {
      phone: formattedPhone,
      otp,
    });
    return response;
  } catch (error) {
    console.error("Verify phone OTP error:", error);
    throw error;
  }
};

// Get verification status
export const getVerificationStatus = async (identifier) => {
  try {
    const response = await api.get(
      `/childcare/verification-status/${encodeURIComponent(identifier)}`,
    );
    return response;
  } catch (error) {
    console.error("Get verification status error:", error);
    throw error;
  }
};

// Step 1: Center Information — CREATE (new registration)
export const submitStep1 = async (formData) => {
  try {
    const response = await uploadApi.post("/childcare/step1", formData);
    return response;
  } catch (error) {
    console.error("Submit step 1 error:", error);
    throw error;
  }
};

// Step 1: Center Information — UPDATE (returning to edit existing data, logo optional)
export const updateStep1 = async (facilityId, formData) => {
  try {
    const response = await uploadApi.put(`/childcare/step1/${facilityId}`, formData);
    return response;
  } catch (error) {
    console.error("Update step 1 error:", error);
    throw error;
  }
};

// Step 2: Admin & Staff
export const submitStep2 = async (data) => {
  try {
    const response = await api.post("/childcare/step2", data);
    return response;
  } catch (error) {
    console.error("Submit step 2 error:", error);
    throw error;
  }
};

// Step 3: Documents
export const submitStep3 = async (formData) => {
  try {
    const response = await uploadApi.post("/childcare/step3", formData);
    return response;
  } catch (error) {
    console.error("Submit step 3 error:", error);
    throw error;
  }
};

// Step 4: Complete Registration
export const completeRegistration = async (data) => {
  try {
    const response = await api.post("/childcare/complete", data);
    return response;
  } catch (error) {
    console.error("Complete registration error:", error);
    throw error;
  }
};

// Get registration data (resume progress)
export const getRegistrationData = async (identifier) => {
  try {
    const response = await api.get(
      `/childcare/registration-data/${encodeURIComponent(identifier)}`,
    );
    return response.data;
  } catch (error) {
    console.error("Get registration data error:", error);
    throw error;
  }
};

// Delete registration data
export const deleteRegistration = async (identifier) => {
  try {
    const response = await api.delete(
      `/childcare/delete-registration/${encodeURIComponent(identifier)}`,
    );
    return response.data;
  } catch (error) {
    console.error("Delete registration error:", error);
    throw error;
  }
};

// Upload additional facility photo
export const uploadFacilityPhoto = async (
  facilityId,
  photoFile,
  isPrimary = false,
) => {
  try {
    const formData = new FormData();
    formData.append("photo", photoFile);
    formData.append("facilityId", facilityId);
    formData.append("isPrimary", isPrimary);

    const response = await uploadApi.post("/childcare/upload-photo", formData);
    return response.data;
  } catch (error) {
    console.error("Upload facility photo error:", error);
    throw error;
  }
};

// Delete facility photo
export const deleteFacilityPhoto = async (photoId, facilityId) => {
  try {
    const response = await api.delete(
      `/childcare/delete-photo/${photoId}/facility/${facilityId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Delete facility photo error:", error);
    throw error;
  }
};

// Reorder facility photos
export const reorderFacilityPhotos = async (facilityId, photos) => {
  try {
    const response = await api.put(`/childcare/reorder-photos/${facilityId}`, {
      photos,
    });
    return response.data;
  } catch (error) {
    console.error("Reorder facility photos error:", error);
    throw error;
  }
};
